"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsService", {
    enumerable: true,
    get: function() {
        return JobsService;
    }
});
const _bull = require("@nestjs/bull");
const _common = require("@nestjs/common");
const _bull1 = require("bull");
const _nocodbsdk = require("nocodb-sdk");
const _Jobs = require("~/interface/Jobs");
const _jobsredis = require("~/modules/jobs/redis/jobs-redis");
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let JobsService = class JobsService {
    // pause primary instance queue
    async onModuleInit() {
        if (process.env.NC_WORKER_CONTAINER === 'false') {
            await this.jobsQueue.pause(true);
        }
        // await this.jobsQueue.add(
        //   {
        //     jobName: JobTypes.DataExportCleanUp,
        //     context: {},
        //   },
        //   {
        //     jobId: JobTypes.DataExportCleanUp,
        //     // run every 5 hours
        //     repeat: { cron: '0 */5 * * *' },
        //   },
        // );
        await this.toggleQueue();
        _jobsredis.JobsRedis.workerCallbacks[_Jobs.InstanceCommands.RESUME_LOCAL] = async ()=>{
            this.logger.log('Resuming local queue');
            await this.jobsQueue.resume(true);
        };
        _jobsredis.JobsRedis.workerCallbacks[_Jobs.InstanceCommands.PAUSE_LOCAL] = async ()=>{
            this.logger.log('Pausing local queue');
            await this.jobsQueue.pause(true);
        };
        await this.add(_Jobs.JobTypes.InitMigrationJobs, {});
    }
    async toggleQueue() {
        if (process.env.NC_WORKER_CONTAINER !== 'true' && process.env.NC_WORKER_CONTAINER !== 'false') {
            // resume primary instance queue if there is no worker
            const workerCount = await _jobsredis.JobsRedis.workerCount();
            const localWorkerPaused = await this.jobsQueue.isPaused(true);
            // if there is no worker and primary instance queue is paused, resume it
            // if there is any worker and primary instance queue is not paused, pause it
            if (workerCount === 0 && localWorkerPaused) {
                await this.jobsQueue.resume(true);
            } else if (workerCount > 0 && !localWorkerPaused) {
                await this.jobsQueue.pause(true);
            }
        }
    }
    async add(name, data, options) {
        await this.toggleQueue();
        const context = _extends({
            workspace_id: _globals.RootScopes.ROOT,
            base_id: _globals.RootScopes.ROOT
        }, (data == null ? void 0 : data.context) || {});
        data = JSON.parse(JSON.stringify(data, (0, _nocodbsdk.getTrueCircularReplacer)()));
        let jobData;
        if (options == null ? void 0 : options.jobId) {
            const existingJob = await _models.Job.get(context, options.jobId);
            if (existingJob) {
                jobData = existingJob;
                if (existingJob.status !== _Jobs.JobStatus.WAITING) {
                    await _models.Job.update(context, existingJob.id, {
                        status: _Jobs.JobStatus.WAITING
                    });
                }
            } else {
                if (_Jobs.SKIP_STORING_JOB_META.includes(name)) {
                    jobData = {
                        id: options.jobId
                    };
                } else {
                    var _data_user;
                    jobData = await _models.Job.insert(context, {
                        id: `${options.jobId}`,
                        job: name,
                        status: _Jobs.JobStatus.WAITING,
                        fk_user_id: data == null ? void 0 : (_data_user = data.user) == null ? void 0 : _data_user.id
                    });
                }
            }
        }
        if (!jobData) {
            if (_Jobs.SKIP_STORING_JOB_META.includes(name)) {
                jobData = {
                    id: await _Noco.default.ncMeta.genNanoid(_globals.MetaTable.JOBS)
                };
            } else {
                var _data_user1;
                jobData = await _models.Job.insert(context, {
                    job: name,
                    status: _Jobs.JobStatus.WAITING,
                    fk_user_id: data == null ? void 0 : (_data_user1 = data.user) == null ? void 0 : _data_user1.id
                });
            }
        }
        if (!data) {
            data = {};
        }
        data.jobName = name;
        if (_Jobs.JobVersions == null ? void 0 : _Jobs.JobVersions[name]) {
            data._jobVersion = _Jobs.JobVersions[name];
        }
        const job = await this.jobsQueue.add(data, _extends({
            jobId: jobData.id,
            removeOnFail: 1000
        }, options));
        return job;
    }
    async jobStatus(jobId) {
        const job = await this.jobsQueue.getJob(jobId);
        if (job) {
            return await job.getState();
        }
    }
    async jobList() {
        return await this.jobsQueue.getJobs([
            _Jobs.JobStatus.ACTIVE,
            _Jobs.JobStatus.WAITING,
            _Jobs.JobStatus.DELAYED,
            _Jobs.JobStatus.PAUSED
        ]);
    }
    async setJobResult(jobId, result) {
        const job = await _models.Job.get({
            workspace_id: _globals.RootScopes.ROOT,
            base_id: _globals.RootScopes.ROOT
        }, jobId);
        if (!job) {
            return;
        }
        try {
            if (typeof result === 'object') {
                result = JSON.stringify(result);
            }
            await _models.Job.update({
                workspace_id: _globals.RootScopes.ROOT,
                base_id: _globals.RootScopes.ROOT
            }, jobId, {
                result
            });
        } catch (e) {
        // ignore
        }
    }
    async resumeQueue() {
        this.logger.log('Resuming global queue');
        await this.jobsQueue.resume();
    }
    async pauseQueue() {
        this.logger.log('Pausing global queue');
        await this.jobsQueue.pause();
    }
    async emitWorkerCommand(command, ...args) {
        return _jobsredis.JobsRedis.emitWorkerCommand(command, ...args);
    }
    async emitPrimaryCommand(command, ...args) {
        return _jobsredis.JobsRedis.emitPrimaryCommand(command, ...args);
    }
    constructor(jobsQueue){
        this.jobsQueue = jobsQueue;
        this.logger = new _common.Logger(JobsService.name);
    }
};
JobsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _bull.InjectQueue)(_Jobs.JOBS_QUEUE)),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _bull1.Queue === "undefined" ? Object : _bull1.Queue
    ])
], JobsService);
